import React from 'react';
import {Map} from 'immutable';
import List from '../screens/list/';
import DatePicker from 'material-ui/DatePicker';
import {connect} from 'react-redux';
import {asyncStart, asyncEnd, showFeedback} from '../actions/application';
import api from '../utility/api';
import RaisedButton from 'material-ui/RaisedButton/RaisedButton';
import { white } from "material-ui/styles/colors";
import appConstants from "../utility/app-constants";
import UpdateAppointmentDialog from '../screens/appointments/update-appointment';
import {
    getListUIPreference
  } from "../utility/local-storage";
import moment from 'moment';
import utils from '../utility/utils';
import {isConnected, setAppointmentUpdater, unsetAppointmentUpdater} from '../utility/socket-handler';

class AppointmentsView extends React.Component {
    constructor() {
        super(...arguments);
        const {defaultSort, pageSize} = this.loadUIPreferences();

        this.state = {
           appointments: Map(),
           doctors: [],
           selectedAppointment: null,
           sortPref: defaultSort,
           pageSize,
           selectedDate: new Date(),
           openUpdateAppointment: false,
           disableSubmit: false,
           updated_start_time:'',
           dateToReschedule: new Date(),
           assignedDoc: '',
           socketConnection: ''
        }
    }

    componentDidMount() {
        this.getAppointments()
        .then(() => {
          setAppointmentUpdater({
            add: (appointment) => this.addAppointment(appointment),
            online: () => this.setState({ socketConnection: 'ONLINE' }),
            offline: () => this.setState({ socketConnection: 'OFFLINE' })
          });

          this.setState({socketConnection: isConnected() ? 'ONLINE' : 'OFFLINE'});
        });
        this.getDoctorsList();
    }

    componentWillUnmount() {
      unsetAppointmentUpdater();
    }

    getAppointments() {
      this.props.dispatch(asyncStart());
      const date = this.state.selectedDate;
      return api.getAppointmentsByDate(date)
      .then(resp => {
          this.props.dispatch(asyncEnd());
          let appointments = Map();
          resp.forEach((appointmentsOfDoctor) => {
              appointmentsOfDoctor.reduction.forEach((appointment) => {
                  appointments = appointments.set(appointment.id, appointment);
              });
          });
          this.setState({ appointments });
        })
        .catch(error => {
          this.props.dispatch(asyncEnd());
          this.props.dispatch(showFeedback({message: error.message}));
        });

    }

    submitReschedule() {
      this.props.dispatch(asyncStart());
      const appointmentId = this.state.selectedAppointment.id;
      const missionId = this.state.selectedAppointment.mission.id;
      const operatorId = this.state.selectedAppointment.mission.assignee.id;
      const doctorId = this.state.assignedDoc 
                       ? this.state.assignedDoc.id 
                       : this.state.selectedAppointment.doctor.id;
      const {dateToReschedule} = this.state;
      let start_time = this.state.updated_start_time;
      start_time = utils.momentDateTime(dateToReschedule, start_time).toISOString();
      const endTime = moment(start_time).add(14, 'minutes').toISOString();

      api.rescheduleAppointment(appointmentId, start_time, endTime, missionId, doctorId, operatorId)
      .then((data) => {
        this.toggleUpdateAppointment();
        this.getAppointments();
        this.props.dispatch(asyncEnd());
        this.props.dispatch(showFeedback({message: "Appointment rescheduled successfully"}));
      })
      .catch(error => {
        this.props.dispatch(asyncEnd());
        this.props.dispatch(showFeedback({message: error.message}));
      })

    }

    getDoctorsList() {
      api.getDoctors()
        .then(resp => {
          resp = resp.filter((doctor) => doctor.user.provider === true);
          this.setState({doctors: resp});
        })
        .catch(error => {
          this.props.dispatch(asyncEnd());
          this.props.dispatch(showFeedback({message: error.message}));
          console.log(error);
        });
    }

    onDateChange(dateType, _, date) {
        this.setState({[dateType]: date}, () => {
            this.getAppointments()
        });
        
        
    }

    addAppointment(appointment) {
      const map = this.state.appointments.set(appointment.id, appointment);
      this.setState({appointments: map});
    }  

    onChange(field, e, value) {
      this.setState({ [field]: value});
    }
    onSelectDoctor(_, __, assignedDoc) {
      this.setState({assignedDoc});
    }
    toggleUpdateAppointment() {
      this.setState({openUpdateAppointment: !this.state.openUpdateAppointment});
    }
    getTdProps(state, rowInfo) {
      const now = moment();
      let style = {
          cursor: 'pointer'
      };
      if(rowInfo && this.isValidReschedule(rowInfo.original)) {
        if (now.diff(moment(rowInfo.original.start_time), 'minutes') >= 5 && (rowInfo.original.mission.mission_mode === "remote") && !rowInfo.original.mission.video_session_id) {
          style.background = '#FA8072';//overdued_but_not_yet_started_remote_mission
        }
        else if (now.diff(moment(rowInfo.original.start_time), 'minutes') >= 5 && (rowInfo.original.mission.mission_mode === "physical") && (!rowInfo.original.mission.investigation_start_time)) {
          style.background = '#FA8072';//overdued_but_not_yet_started_physical_mission
        }
        else if (rowInfo.original.active && rowInfo.original.reminded) {
          style.background = '#9ACD32'; //upcoming_appointments
        }
        else {
          style.background = 'white';
        }
      }
      return {
        style
      }
    }

    loadUIPreferences() {
      const listPreference = getListUIPreference(
        appConstants.LIST.APPOINTMENTS
      );
      const defaultSort =
        listPreference && listPreference.sortPref
          ? listPreference.sortPref
          : [
              {
                id: "start_time",
                desc: false,
              },
            ];
      const pageSize =
        listPreference && listPreference.sortPref ? listPreference.pageSize : 20;
  
      return { defaultSort, pageSize };
    }

    isValidReschedule(appointment) {
      if(appointment.mission.status === "investigating" || appointment.mission.status === "follow-up" || appointment.mission.status === "on-follow-up" || appointment.mission.status === "done") {
        return false;
      }
      return true;
    }
    

    render() {
        const columns = [
          {
              id: 'Patient',
              Header: 'Patient',
              accessor: d => d.patient.name ? d.patient.name : ''
          },
          {
              id: 'Caller',
              Header: 'Caller',
              accessor: d => d.patient ? d.patient.user.name : ''           
          },
          {
              id: 'Doctor',
              Header: 'Doctor',
              accessor: d => d.doctor.user.name
          },
          {
              Header:"Doctor's Phone",
              accessor: 'doctor.user.phone'
          },
          {
              id: 'start',
              Header: 'Start Time',
              accessor: 'start_time',
              Cell: props => <span>{utils.toAppDate(props.value)}</span>
          },
          {
              Header: 'Reschedule',
              Cell: ({original}) => (
                  <RaisedButton
                  label={this.isValidReschedule(original) ? "Reschedule" : original.mission.status}
                  labelColor={white}
                  backgroundColor="#14A46E"
                  width="160px"
                  disabled={!this.isValidReschedule(original)}
                  onClick={(e) => {
                      this.setState({
                        selectedAppointment: original,
                        openUpdateAppointment: true
                      });
                    }}
                  />
              )
          }
        ]
        const {appointments, sortPref, selectedAppointment, selectedDate, updated_start_time, openUpdateAppointment, disableSubmit, dateToReschedule, doctors, assignedDoc, socketConnection} = this.state;

        const {isLoading} = this.props.application;

        const reactTableProps = {
          data: appointments.toArray(),
          columns,
          isLoading,
          noDataText: 'No appointments found for this day',
          defaultSorted: sortPref,
          getTdProps: this.getTdProps.bind(this)
        };

        return (
          <div>
            <DatePicker
              value={selectedDate}
              floatingLabelText="Select Date"
              firstDayOfWeek={0}
              onChange={this.onDateChange.bind(this, 'selectedDate')} 
            /> 
            <List
              title="Appointments"
              addNewBadge={socketConnection}
              reactTableProps={reactTableProps}
            />
            <UpdateAppointmentDialog
              open={openUpdateAppointment}
              dateToReschedule={dateToReschedule}
              updated_start_time={updated_start_time}
              selectedAppointment={selectedAppointment}
              doctors={doctors}
              assignedDoc={assignedDoc}
              onChange={this.onChange.bind(this)}
              submitReschedule={this.submitReschedule.bind(this)}
              onSelectDoctor={this.onSelectDoctor.bind(this)}
              disableSubmit={disableSubmit}
              toggleUpdateAppointment={this.toggleUpdateAppointment.bind(this)}
              onDateChange = {this.onDateChange.bind(this)} 
            />
          </div>

        )
    }
}

function mapStateToProps(state) {
    return {
      application: state.application,
      user: state.user
    }
  }
  

export default connect(mapStateToProps, null) (AppointmentsView);


// WEBPACK FOOTER //
// ./src/containers/appointments.js